import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

import { environment } from '../../../environments/environment';
import { IClientApprovalNotes } from '../models';
import { IRateAmendmentDocAdd, IRateChangeRequestAdd } from '../../applicant/models'

@Injectable({
  providedIn: 'root'
})
export class ApplicantRateChangeService {
  constructor(private http: HttpClient,
    private apiService: ApiService) { }
  public getAllApplicantRateChangeRequest(userApprovalSearchParam: IGlobalSearchParam): Observable<any> {
    return this.apiService.post(`InvoiceEligibleApplicants/SearchApplicantBillRateChangeRequest`, userApprovalSearchParam)
  }
  // GetApplicantCurrentBillRateForChangeRequest
  public GetApplicantCurrentBillRateForChangeRequest(vendorCompanyId: number, applicantReferenceId: string, tpsReferenceId: string): Observable<any> {
    return this.apiService.get(`InvoiceEligibleApplicants/GetApplicantCurrentBillRateForChangeRequest/${vendorCompanyId}/${applicantReferenceId}/${tpsReferenceId}`);
  }

        public submitRateRequest(rateRequest:IRateChangeRequestAdd):Observable<any> {
         
          return this.apiService.post(`InvoiceEligibleApplicants/SubmitRateChangeRequest`, rateRequest);
        }
         // GetApplicantCurrentBillRateForChangeRequest
         public GetApplicantBillRateChangeRequestHistory(vendorCompanyId:number,applicantReferenceId: string,uid:number):Observable<any>{
          return this.apiService.get(`InvoiceEligibleApplicants/ApplicantBillRateChangeRequestHistory/${vendorCompanyId}/${applicantReferenceId}/${uid}`);
        }

         // GetApplicantBillRateChangeHistoryForVendor
         public GetApplicantBillRateChangeHistoryForVendor(applicantReferenceId: string,uid:number):Observable<any>{
          return this.apiService.get(`InvoiceEligibleApplicants/ApplicantBillRateChangeHistoryForVendor/${applicantReferenceId}/${uid}`);
        }
        public approve(value): Observable<any> {
          return this.apiService.post(`InvoiceEligibleApplicants/ApproveInvoiceApplicantRateChangeRequest`, value);
        }
      
        public reject(value): Observable<any> {
          return this.apiService.post(`InvoiceEligibleApplicants/RejectInvoiceApplicantRateChangeRequest`, value);
      }

      // GetApplicantInvoiceCurrentBillRate
      public GetApplicantInvoiceCurrentBillRate(applicantId:number, tsStartDate: string, tsEndDate: string):Observable<any>{
        return this.apiService.get(`InvoiceEligibleApplicants/GetApplicantInvoiceCurrentBillRate?applicantId=${applicantId}&StartDate=${tsStartDate}&EndDate=${tsEndDate}`);
      }
      public submitApplicantRateAmendment(value:IRateAmendmentDocAdd): Observable<any> {
        return this.apiService.post(`ApplicantRateAmendmentDoc/SubmitApplicantRateAmendmentDoc`, value);
      }
      public getRejectionNotes(invoiceEligibleApplicantId:number, approvalStatusId: number):Observable<any>{
        return this.apiService.get(`InvoiceEligibleApplicants/GetRejectionNotes?invoiceEligibleApplicantId=${invoiceEligibleApplicantId}&approvalStatusId=${approvalStatusId}`);
      }
}